<card-info-detail-v2 class="content-detail" [showButton]="false">
  <h2 title class="name" i18n="@@checktimes_horarios">Horarios</h2>

  <div expanded-info class="text">
    <p class="in">
      <span i18n="@@checktimes_a_partir_de_las">Check in: </span> <br *ngIf="!mobile" />

      <span i18n="@@filters_discount_from">Desde </span>
      <strong>{{ staticInfo?.checkin_time }} Hs</strong>
    </p>

    <p class="out">
      <span i18n="@@checktimes_hasta_las">Check out: </span><br *ngIf="!mobile" />

      <span i18n="@@filters_discount_to">Hasta </span>
      <strong>{{ staticInfo?.checkout_time }} Hs</strong>
    </p>
  </div>
</card-info-detail-v2>
